export default {
  title: 'AIRPORT - PICKUP TIME OFFSETS',
  items: {
    PickupTimeOffsets: {
      label: 'Pickup Time Offsets',
      type: 'pickuptime-offsets',
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/pickuptime-offsets.js